
import React, {useEffect, useRef, useState} from "react";
import {FormOutlined, DeleteOutlined, SearchOutlined, PlusOutlined, QuestionCircleOutlined,ExportOutlined} from "@ant-design/icons";
import {Breadcrumb, Button, Divider, message, Modal, Popconfirm, Popover, Space, Tag} from "antd";
import MyProLayout from "../../components/MyProLayout";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
// import SeoTaskEditor from "./SeoTaskEditor";
import DataUtil from "../../utils/DataUtil";
import moment from "moment";
import BlogCrawlEditor from "./BlogCrawlEditor";

const {confirm} = Modal

const executeStatusEnum = [
    {value: 0, label: '等待' },
    {value: 1, label: '执行中' },
    {value: 2 , label: '完成' },
    {value: 3 , label: '暂停' },
    {value: 9 , label: '失败' },
]

const BlogCrawlIndex = (prop: any) => {

    const actionRef = useRef<ActionType>();
    const formRef = useRef();
    const logsRef = useRef();

    const [stat, setStat] = useState<any>();

    useEffect(() => {
    }, []);

    const openLogs = (r?: any) => {
        (logsRef.current as any).openEditor(r.id);
    }
    const openEdit = (r?: any) => {
        if (!r) {
            r = {sendTime: new Date()};
        }
        (formRef.current as any).openEditor(r);
    }

    const columns: any[] = [
        {
            title: "ID", dataIndex: "id",
            align: "center" as "center",
            width: 40,
            hideInSearch: true,
            hideInForm: true
        },
        {
            title: '主图',
            dataIndex: 'blogImage',
            valueType: 'image',
            align: "center" as "center",
            width: 100,
            // hideInTable: true,
            hideInSearch: true,
            required: true
        },
        {
            title: '标题',
            dataIndex: 'blogTitle',
            width: 200,
            render: (v: string, r: any) => <a onClick={() => openEdit(r)}>{v}</a>,
            required: true
        },
        {
            title: '文章内容',
            dataIndex: 'blogContent',
            valueType: "rich2",
            hideInTable: true,
            hideInSearch: true,
            required: true
        },
        {
            title: '源网站',
            dataIndex: 'blogUrl',
            width: 80,
            // hideInTable: true,
            hideInSearch: true,
            required: true,
            render: (v: string, r: any) => <a href={v} target="_blank">{r.webName}</a>,
        },
        {
            title: 'AI状态',
            dataIndex: 'aiStatus',
            align: 'center' as 'center',
            width: 80,
            hideInForm: true,
            valueType: "select",
            fieldProps: {options: executeStatusEnum},
            render: (v: number, r:any) => DataUtil.formatExecuteStatus(r.aiStatus),
            // hideInSearch: true
        },
        {
            title: 'Blog时间',
            dataIndex: 'blogTime',
            align: 'center' as 'center',
            width: 100,
            valueType: "dateTime",
            hideInForm: true,
            hideInSearch: true
        },
        {
            title: '抓取时间',
            dataIndex: 'createTime',
            align: 'center' as 'center',
            width: 100,
            valueType: "dateTime",
            hideInForm: true,
            hideInSearch: true
        },
        {
            dataIndex: '__preview',
            width: 100,
            valueType: "preview",
            // hideInTable: true,
            hideInSearch: true,
        }
        // {
        //     title: '操作',
        //     dataIndex: '_',
        //     width: 60,
        //     align: "center" as "center",
        //     render: (v: string, r: any) => {
        //         return (<Space size={0} split={<Divider type="vertical"/>}>
        //             <a onClick={() => openEdit(r)}><FormOutlined/></a>
        //             <Popconfirm disabled={false}
        //                         title="确定要删除这条记录吗"
        //                         okText="删除"
        //                         cancelText={"再想想"}
        //                         onConfirm={() => deleteRecord(r)}
        //             >
        //                 <a><DeleteOutlined/></a>
        //             </Popconfirm>
        //         </Space>)
        //     },
        //     hideInForm: true,
        //     hideInSearch: true
        // },
    ];

    // const deleteRecord = async (r: any) => {
    //     const res = await FetchUtil.awaitFetch('/mallApi/seo/taskDelete', [r.id]);
    //     if (res.code === 200) {
    //         message.success({content: '记录已删除成功！'});
    //         actionRef.current?.reload();
    //     }
    // }
    //
    // const btnAddNew = async (taskId: number) => {
    //     confirm({
    //         title: '确认【一键补发】当前任务？',
    //         icon: <QuestionCircleOutlined/>,
    //         content: '【一键补发】将之前未发送的新增站点添加到发送列表，并自动开始发送！',
    //         okText: "确认一键补发",
    //         cancelText: "取消",
    //         async onOk() {
    //             const res = await FetchUtil.awaitFetch("/mallApi/seo/taskAddnew", [taskId])
    //             if (res.code === 200) {
    //                 message.success("任务已设置为一键补发！");
    //                 actionRef.current?.reload();
    //
    //             } else {
    //                 message.error(res.msg);
    //             }
    //         },
    //         onCancel() {
    //             console.log('Cancel');
    //         },
    //     });
    // }

    return (
        <MyProLayout>
            <ProTable
                rowKey={"id"}
                headerTitle={stat}
                toolbar={{
                    actions: [
                        <Button type='primary' onClick={() => openEdit()} key='0'><PlusOutlined/> 新建</Button>
                    ],
                }}
                actionRef={actionRef}
                columns={columns}
                cardBordered={true}
                request={async (
                    params,
                    // sort,
                    // filter,
                ) => {
                    const query: any = {
                        seoTask: {...params},
                        page: {
                            pageNo: params.current,
                            pageSize: params.pageSize,
                            orderBy: " id desc"
                        }
                    }
                    const res = await FetchUtil.awaitFetch('/mallApi/blog/crawlList', query);
                    console.log(res)
                    return {
                        success: true,
                        data: res.data.list,
                        total: res.data.total,
                    };
                }}
            />
        <BlogCrawlEditor ref={formRef} columns={columns} callback={() => actionRef.current?.reload()} />

        </MyProLayout>
    );
}

export default BlogCrawlIndex;
